export const RACE_DATA = [
	{ label: '', value: '' },
	{ label: 'Malay', value: 'malay' },
	{ label: 'Chinese', value: 'chinese' },
	{ label: 'Indian', value: 'indian' },
	{ label: 'Others', value: 'others' },
	{
		label: 'Non-Malaysian Residents',
		value: 'non-malaysian'
	}
];

export const STATE_DATA = [
	{ label: '', value: '' },
	{
		label: 'Selangor',
		value: 'Selangor'
	},
	{
		label: 'WP Kuala Lumpur',
		value: 'WP Kuala Lumpur'
	},
	{
		label: 'Sarawak',
		value: 'Sarawak'
	},
	{
		label: 'Johor',
		value: 'Johor'
	},
	{
		label: 'Sabah',
		value: 'Sabah'
	},
	{
		label: 'Perak',
		value: 'Perak'
	},
	{
		label: 'Pahang',
		value: 'Pahang'
	},
	{
		label: 'Negeri Sembilan',
		value: 'Negeri Sembilan'
	},
	{
		label: 'Kedah',
		value: 'Kedah'
	},
	{
		label: 'Melaka',
		value: 'Melaka'
	},
	{
		label: 'Terengganu',
		value: 'Terengganu'
	},
	{
		label: 'Kelantan',
		value: 'Kelantan'
	},
	{
		label: 'Perlis',
		value: 'Perlis'
	},
	{
		label: 'WP Labuan',
		value: 'WP Labuan'
	},
	{
		label: 'WP Putrajaya',
		value: 'WP Putrajaya'
	},
	{
		label: 'Pulau Pinang',
		value: 'Pulau Pinang'
	}
];
